import { useSelector } from 'react-redux';
import type { VoidFunctionComponent } from 'react';

import ProjectsModule from '../../../redux/projects';
import Loader from '../../generic/Loader';
import type { ReleaseGroupDetail } from '../../../../shared/releaseGroups';
import type { ProjectGroupRelease } from '../../../types';

import ProjectGroupReleaseProjectsTable from './components/ProjectGroupReleaseProjectsTable';
import ProjectGroupReleaseProjectsTableHeader from './components/ProjectGroupReleaseProjectsTableHeader';

type Props = {
  //  These are passed down from ProjectGroupContainer. The release is undefined while it loads.
  projectGroup: ReleaseGroupDetail;
  projectGroupRelease?: ProjectGroupRelease;
};

const ProjectGroupProjectsTab: VoidFunctionComponent<Props> = ({ projectGroup, projectGroupRelease }) => {
  const projectsStatus = useSelector(ProjectsModule.selectors.getStatus);
  if (!projectGroupRelease) {
    return <Loader />;
  }
  return (
    <div className="container project-group-projects-page-body">
      <div className="select-projects">
        <ProjectGroupReleaseProjectsTableHeader
          releaseProjects={projectGroupRelease.projects}
          projectGroupId={projectGroup.id}
          selectedRelease={projectGroupRelease}
        />
        <ProjectGroupReleaseProjectsTable
          releaseProjects={projectGroupRelease.projects}
          projectsStatus={projectsStatus}
          sortableBranchCommit
          readOnly
        />
      </div>
    </div>
  );
};

export default ProjectGroupProjectsTab;
